// @ts-nocheck

import React from 'react';
import styled, { css, keyframes } from 'styled-components';

import { MoreSvg } from '../../../../assets/svg/history';
import theme from '../../../../styled-components/dark';

const flashAnimation = keyframes`
  47% {
    transform: scale(1);
    filter: brightness(100%);
  }
  50% {
    transform: scale(1.2);
    filter: brightness(200%);
  }
  53% {
    transform: scale(1);
    filter: brightness(100%);
  }
`;

const Wrapper = styled.div`
  width: 2em;
  height: 2em;
  padding: 0.27em;
  border-radius: 100%;
  cursor: pointer;

  color: ${theme.History.betslip.header.button.color};
  background: ${({ $hideBackground }) =>
    $hideBackground ? 'transparent' : theme.History.betslip.header.button.backgroundColor};

  transition: transform 150ms ease-in-out;

  &:active {
    transform: scale(0.95);
  }

  ${({ $isFlashing }) =>
    $isFlashing
      ? css`
          animation: ${flashAnimation} 3000ms ease-in-out infinite;
        `
      : null}
`;

const MoreIcon = styled(MoreSvg)`
  height: 1.6em;
  width: 2.25em;

  transform: translate(-0.4em, -0.05em);
`;

type BetslipOptionsButtonProps = {
  className?: string;
  hideButtonBackground?: boolean;
  onClick: () => void;
  betslipReference: string;
  uuid: string;
  isFlashing?: boolean;
  'data-testid'?: string;
};

const BetslipOptionsButton = ({
  className = '',
  hideButtonBackground,
  onClick,
  betslipReference,
  uuid,
  isFlashing,
  'data-testid': testId,
}: BetslipOptionsButtonProps) => {
  return (
    <Wrapper
      id={`odd-button-${betslipReference}-${uuid}`}
      className={className}
      onClick={onClick}
      $hideBackground={hideButtonBackground}
      $isFlashing={isFlashing}
      data-testid={testId}
    >
      <MoreIcon />
    </Wrapper>
  );
};

export default BetslipOptionsButton;
